<template>
  <tr>
    <td style="width: 20px;">
      <v-progress-circular v-if="status == 'processing'" indeterminate :size="20" :width="2" color="deep-orange"></v-progress-circular>
      <v-icon v-if="status == 'ready'" color="deep-orange">done</v-icon>
      <v-icon v-if="status == 'error'" color="deep-orange">error</v-icon>
    </td>
    <td style="white-space:nowrap; width: 100%;"><span style="margin-right: 10px;">{{value.description}}</span><Clip v-for="(uuid, index) in value.meta.uuids" :key="'clip-'+uuid+'-'+index" :index="index" :uuid="uuid" :event_uuid="value.meta.event_uuid" @status_changed="status_changed"></Clip></td>
    <td style="white-space:nowrap;">{{format_timestamp(value.created_at)}}</td>
    <td class="text-xs-right" style="white-space:nowrap;">
      <v-btn flat fab color="deep-orange" small @click="open_process(value.uuid)"><v-icon>open_in_new</v-icon></v-btn>
      <v-btn flat fab color="deep-orange" small @click="remove_process(value.uuid)"><v-icon>close</v-icon></v-btn>
    </td>
  </tr>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import _ from 'lodash'
import Clip from './cloudrec/clip.vue'

export default {
  props: ['value'],
  components: {
    Clip
  },
  data: () => ({
    clip_status: {},
    //status: "new"
  }),
  created() {
    _.each(this.value.meta.uuids, (uuid, index) => {
      this.$set(this.clip_status, index, "new");
    });
  },
  methods: {
    ...mapMutations({
      remove_process: 'processes/remove'
    }),
    open_process() {
      this.$router.push("/cloudrec/event/"+this.value.meta.event_uuid)
    },
    status_changed(index, status) {
      this.$set(this.clip_status, index, status);
    },
    format_timestamp(ts) {
      var m = moment.utc(ts);
      return m.local().format("L LTS");
    }
  },
  computed: {
    status () {
      var status_list = ["processing", "new", "error", "ready"];
      return _.minBy(_.values(this.clip_status), (status) => { return status_list.indexOf(status); });
    }
  }
}
</script>
